import React from 'react';
import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './Buttons.module.scss';
import useNotification from '../../Hooks/useNotification.hook';
import useTranslation from '../../Hooks/useTranslation';

interface Props {
	onClick: () => void;
	title?: string;
	isDisabled?: boolean;
	disabledAlert?: string;
}

const ExportButton: React.FC<Props> = ({
	onClick,
	title = 'base.export',
	isDisabled = false,
	disabledAlert,
}) => {
	const { showNotificationAlert } = useNotification();
	const { t } = useTranslation();
	const handlePress = () => {
		if (isDisabled) {
			if (disabledAlert) {
				showNotificationAlert({ content: t(disabledAlert) });
			}
		} else {
			onClick();
		}
	};

	return (
		<div className={styles.actionButton} onClick={handlePress}>
			<img
				className={styles.icon}
				src={
					isDisabled
						? '/dist/icons/export-disabled.svg'
						: '/dist/icons/export.svg'
				}
				alt={'printer icon'}
			/>
			<Text
				className={isDisabled ? styles.disabledTitle : styles.title}
				tx={title}
				inline={true}
				firstUpper={true}
			/>
		</div>
	);
};

export default ExportButton;
